import ResponsiveIframe from './ResponsiveIframe';

export default ResponsiveIframe;
